import { ApolloClient } from '@apollo/client';

const DEFAULT_CONTEXT = 'default';

export default class J1ApolloClient {
  static _shared: Record<string, ApolloClient<any>> = {};

  static setShared(
    client: ApolloClient<any>,
    context: string = DEFAULT_CONTEXT
  ) {
    this._shared[context] = client;
  }

  static shared(context: string = DEFAULT_CONTEXT): ApolloClient<any> {
    const shared = this.sharedOptional(context);
    if (!shared) {
      throw new Error('No apollo client initialized yet.');
    }
    return shared;
  }

  static sharedOptional(
    context: string = DEFAULT_CONTEXT
  ): ApolloClient<any> | null {
    return this._shared[context];
  }
}
